(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["found-road-bathurst-product"]) return;
  try {
    
if (!customElements.get('fr-book-gallery')) {
  customElements.define('fr-book-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-book-select]');
        if (!button) return;
        const selected = button.dataset.bookSelect;
        this.querySelectorAll('[data-book-image]').forEach(image => { image.hidden = image.dataset.bookImage !== selected; });
        this.querySelectorAll('[data-book-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["found-road-book-product"]) return;
  try {
    
if (!customElements.get('fr-book-gallery')) {
  customElements.define('fr-book-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-book-select]');
        if (!button) return;
        const selected = button.dataset.bookSelect;
        this.querySelectorAll('[data-book-image]').forEach(image => { image.hidden = image.dataset.bookImage !== selected; });
        this.querySelectorAll('[data-book-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["found-road-panorama"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fr-panorama-reel')) {
  customElements.define('fr-panorama-reel', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      if (!this.video) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onMotionChange = () => {
        this.video.autoplay = !this.motion.matches;
        if (this.motion.matches) this.video.pause();
        else this.video.play().catch(() => {});
      };
      this.onMotionChange();
      this.motion.addEventListener('change', this.onMotionChange);
    }
    disconnectedCallback() {
      if (this.motion) this.motion.removeEventListener('change', this.onMotionChange);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
